export default __webpack_public_path__ + "static/media/119.1fc525d3.jpg";